export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8080/api";
export const APP_NAME = "Sulsa";

export const LOGIN_URL = "/login";

export const AUTH_TOKEN_NAME = 'AUTH_TOKEN';

export const REFRESH_TOKEN_NAME = 'REFRESH_TOKEN';

export const USER_OBJECT_NAME = 'USER_OBJECT';

export const USER_ACCESS = 'USER_ACCESS';

// Active store id (store-management Phase 4) — persisted across reloads so
// the user does not need to re-pick their store after a refresh. Cleared
// on logout / session revocation alongside the tokens.
export const ACTIVE_STORE_ID_NAME = 'ACTIVE_STORE_ID';

// Snapshot of the user's active assigned stores from POST /auth/login
// (store-management Phase 5). Drives the Store Selection screen and the
// topbar Store Switcher visibility. Cleared on logout.
export const ASSIGNED_STORES_NAME = 'ASSIGNED_STORES';

export const API_MOCKING_ENABLED = false;

